import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OcrAccessToken, OcrDocumentJob, OcrDocumentJobRequest, TempUploadResult } from '../models/OcrDocumentJob';
import { documentMap } from '../const/caseWiseDocument';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {

  baseUrl = environment.apiBaseUrl;
  apiClaimsUrl = environment.apiClaimsUrl;
  // OCR calls skip the interceptors: no portal token goes to the OCR host, and a failed
  // background poll never opens the global error popup over the claim form
  private ocrHttp: HttpClient;
  private readonly OCR_TOKEN_STORAGE_KEY = 'ocrAccessToken';

  constructor(private http: HttpClient, private authService: AuthService, httpBackend: HttpBackend) {
    this.ocrHttp = new HttpClient(httpBackend);
  }

  fetchDashboard(page:any,size:any,claimStatus: string, purpose: any, claimAdminId: any) {
    let params;
    params = {
    "purpose": purpose,
    "claimStatus": claimStatus,
    "isUnderInvestigation":false,
    "isDataEntry":false,
    "claimSubReason":[""],
    "providerId":this.authService.currentUserValue.providerBranch.id,
    "claimType":"CASHLESS_CLAIM",
    "claimAdminId": claimAdminId
    }
   let param = new HttpParams().set('page', page).set('size', size)
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      params: param
    };
    return this.http.post(this.baseUrl + '/trueclaim/claims/sent-items-status-wise-count', params,options);
  }


  getClaimDetailsList(page:any,size:any,purpose: string, tpaFilter: string, statusFilter: string) {
    let params;
    params = new HttpParams().set('page', page).set('size', size)
      .set('purpose', purpose)
      .set('tpaFilter', tpaFilter)
      .set('statusFilter', statusFilter);
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-claims-details-list', options);
  }


  getClaimSummaryCounts() {
    let params;
    params = new HttpParams()
      .set('providerId', this.authService.currentUserValue.providerBranch.id);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/claim-summary-counts', options);
  }

  getClaimDetails(claimId: any) {
    let params;
    params = new HttpParams()
      .set('id', claimId);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-claim-details', options);
  }

  getAllTPA() {
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-all-tpa');
  }

  getAllStatus(statusTag: any) {
    let params;
    params = new HttpParams()
      .set('statusTag', statusTag);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-all-claim-status', options);
  }

  getAllCorporates() {
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-all-corporates');
  }

  getAllMembers(cId: any, cName: any, eId: any) {
    const params = new HttpParams().set('tpaCorporateId', cId)
      .set('corporate', cName)
      .set('employeeId', eId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claim/get-all-members-by-employee-id', options);
  }

  getAllByMemberId(memberId: any, claimAdminId: any) {
    const params = new HttpParams()
      .set('memberId', memberId)
      .set('claimAdminId', claimAdminId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/member/get-all-by-member-id', options);
  }

  getMemberDetailsByMemberId(memberId: any,claimAdminId:any) {
    const params = new HttpParams().set('memberId', memberId).set('claimAdminId', claimAdminId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claim/get-members-details-by-member-id', options);
  }

  fetchMemberClaimDetails(req_params: any) {
    let arrayObj = [];
    let params = new HttpParams();
    arrayObj = Array.from(req_params);
    arrayObj.forEach((data: any) => {
      if (data[1] !== '' && data[1] !== undefined) {
        params = params.set(data[0], data[1]);
      }
    });
    const options = {
      params: params,
    };
    return this.http.get(this.baseUrl + '/trueclaim/claim/global-search', options);
  }

  assignClaim(claimId: any) {
    let params;
    params = new HttpParams()
      .set('claimId', claimId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/assignClaim', options);
  }

  isClaimAssign(claimId: any) {
    let params;
    params = new HttpParams()
      .set('claimId', claimId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/isClaimAssign', options);
  }

  releaseClaim(claimId: any) {
    let params;
    params = new HttpParams()
      .set('claimId', claimId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/releaseClaim', options);
  }

  raiseEnhancement(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/raise-enhancement', data);
  }

  submitCashlessClaim(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/submit-cashless-claim', data);
  }

  saveTpaClaimId(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/save-tpa-claimid', data);
  }

  submitCashlessClaimOtherPayer(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/submit-cashless-claim-other-payer', data);
  }

  getAllDocumentTypes() {
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-all-document-types');
  }

  providerGetTariff(insurerId: any, claimAdministratorId: any, providerId: any) {
    const params = new HttpParams()
      .set('providerId', providerId)
      .set('insurerId', insurerId)
      .set('claimAdministratorId', claimAdministratorId);

    const options = {
      params: params,
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getInsurerPorviderTariffMapping', options);
  }

  fetchDocument(documentUrl: any) {
    let params;
    params = new HttpParams()
      .set('documentUrl', documentUrl);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/get-claim-doc-url', options);
  }

  searchPcsDescription(pcsDescription: any,lineOfTreatment:any) {
    let params;
    params = new HttpParams()
      .set('pcsDescription', pcsDescription).set('lineOfTreatment',lineOfTreatment);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/autoCompletePcsDescription', options);

    return this.http.get(this.baseUrl + '/trueclaim/search/search-pcs-description', options);
  }

  searchPcsCode(pcsCode: any) {
    let params;
    params = new HttpParams()
      .set('pcsCode', pcsCode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/autoCompletePcsCode', options);

    return this.http.get(this.baseUrl + '/trueclaim/search/search-pcs-code', options);
  }

  getPcsCodeByGipsaProcedures(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/get-pcs-code-by-gipsa-procedures', data);
  }



  searchIcdDescription(icdDesc: any,lineOfTreatment:any) {
    let params;
    params = new HttpParams()
      .set('icdLabel', icdDesc).set('lineOfTreatment',lineOfTreatment);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/autoCompleteIcdLabel', options);
    return this.http.get(this.baseUrl + '/trueclaim/search/search-icd-description', options);
  }

  searchIcdCode(icdCode: any) {
    let params;
    params = new HttpParams()
      .set('icdCode', icdCode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/autoCompleteIcdCode', options);

    return this.http.get(this.baseUrl + '/trueclaim/search/search-icd-code', options);
  }

  getEnhancementItems(claimId: any) {
    const params = new HttpParams().set('claimId', claimId);
    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claim/getEnhancementItems', options);
  }

  ailmentSearch(qStr: any,lineOfTreatment:any,tariffType:any) {
    let params;
    // params = new HttpParams()
    //   .set('qStr', qStr);
    params = new HttpParams()
      .set('commonName', qStr).set('lineOfTreatment',lineOfTreatment).set('tariffType',tariffType);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/autoCompleteCommonName', options);

    // return this.http.get(this.baseUrl + '/trueclaim/search/ailment-search', options);
  }

  getAllClaimAdministrators() {
    return this.http.get(this.baseUrl + '/trueclaim/claimAdministrator/getAllClaimAdministrators');
  }

  // TODO: Need to add this for getting mandatory documents by ailments. 
  getMendatoryDocumentsByAilments(ailments : any[], claimType: string,treatmentType: string) {
    let password = environment.mdpPassword;
    let body = {
    "password": password,
    "ailment": ailments, 
    "claim_type" : claimType,
    "treatment_type" : treatmentType
    }
    
    return this.http.post(environment.mdpApiBaseUrl + '/mdp', body );
  }

  // caseTypes e.g. ['All', 'Pre-Auth', 'Accidental Case']; admissionType 'Emergency' | 'Planned' ('All' rows always match)
  getAllDocumentByCaseType(caseTypes: string | string[], admissionType?: string) {
    const cases = Array.isArray(caseTypes) ? caseTypes : [caseTypes];
    const documentList = documentMap.filter(doc =>
      cases.includes(doc.case_type) &&
      (!admissionType || doc.admission_type === 'All' || doc.admission_type === admissionType));
    return documentList;
  }

  // ---- OCR "Upload and Fill" ----

  // Step 1c: each file goes to the temp bucket as soon as it is added; signedUrl is handed to OCR
  uploadDocumentToTempBucket(file: File): Observable<TempUploadResult> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.baseUrl + '/trueclaim/documents/temp/upload', formData).pipe(
      map((res: any) => {
        if (!res?.body?.signedUrl) {
          throw new Error(res?.message || 'Temp upload returned no signed URL');
        }
        return res.body as TempUploadResult;
      })
    );
  }

  createOcrDocumentJob(request: OcrDocumentJobRequest): Observable<OcrDocumentJob> {
    return this.withOcrToken(headers => this.ocrHttp.post<OcrDocumentJob>(
      `${environment.ocrApiBaseUrl}/v1/tenants/${environment.ocrTenantId}/document-jobs`, request, { headers }));
  }

  // poll_url comes back relative (/v1/tenants/...); fall back to building it from the job id
  getOcrDocumentJob(job: Pick<OcrDocumentJob, 'job_id' | 'poll_url'>): Observable<OcrDocumentJob> {
    const path = job.poll_url || `/v1/tenants/${environment.ocrTenantId}/document-jobs/${job.job_id}`;
    const url = /^https?:\/\//i.test(path) ? path : environment.ocrApiBaseUrl + path;
    return this.withOcrToken(headers => this.ocrHttp.get<OcrDocumentJob>(url, { headers }));
  }

  // ---- OCR access token (POST /token with the API key, cached in localStorage until expires_at) ----

  fetchOcrAccessToken(): Observable<OcrAccessToken> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${environment.ocrApiKey}`);
    return this.ocrHttp.post<OcrAccessToken>(
      `${environment.ocrApiBaseUrl}/v1/tenants/${environment.ocrTenantId}/token`, {}, { headers }
    ).pipe(
      map(token => {
        this.setOcrAccessToken(token);
        return token;
      })
    );
  }

  // Cached token while it has more than a minute left, otherwise a new one
  getOcrAccessToken(): Observable<string> {
    const cached = this.getStoredOcrAccessToken();
    return cached ? of(cached) : this.fetchOcrAccessToken().pipe(map(token => token.access_token));
  }

  setOcrAccessToken(token: OcrAccessToken) {
    const expiresAt = token.expires_at
      ? new Date(token.expires_at).getTime()
      : Date.now() + (token.expires_in || 0) * 1000;
    try {
      localStorage.setItem(this.OCR_TOKEN_STORAGE_KEY, JSON.stringify({ accessToken: token.access_token, expiresAt }));
    } catch (e) {
      // storage unavailable (private mode): the token is simply fetched again next time
    }
  }

  getStoredOcrAccessToken(): string | null {
    try {
      const stored = JSON.parse(localStorage.getItem(this.OCR_TOKEN_STORAGE_KEY) || 'null');
      if (stored?.accessToken && stored.expiresAt - Date.now() > 60000) {
        return stored.accessToken;
      }
    } catch (e) {
      // unreadable entry: treated as no token
    }
    return null;
  }

  clearOcrAccessToken() {
    try {
      localStorage.removeItem(this.OCR_TOKEN_STORAGE_KEY);
    } catch (e) {
      // nothing to clear
    }
  }

  // Runs an OCR call with the Bearer token; on 401 (token revoked early) gets a new token and retries once
  private withOcrToken<T>(call: (headers: HttpHeaders) => Observable<T>): Observable<T> {
    const bearer = (token: string) => new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.getOcrAccessToken().pipe(
      switchMap(token => call(bearer(token))),
      catchError(error => {
        if (error?.status !== 401) {
          return throwError(error);
        }
        this.clearOcrAccessToken();
        return this.fetchOcrAccessToken().pipe(switchMap(token => call(bearer(token.access_token))));
      })
    );
  }


  getIcdCodeByIcdLabel(icdLabel: any) {
    let params;
    params = new HttpParams()
      .set('icdLabel', icdLabel);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/getIcdCodeByIcdLabel', options);

    return this.http.get(this.baseUrl + '/trueclaim/icdcodes/getIcdCodeByIcdLabel', options);
  }

  getIcdLabelByIcdCode(icdCode: any) {
    let params;
    params = new HttpParams()
      .set('icdCode', icdCode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/getIcdLabelByIcdCode', options);

    return this.http.get(this.baseUrl + '/trueclaim/icdcodes/getIcdLabelByIcdCode', options);
  }

  getPcsCodeByPcsDescription(pcsDescription: any) {
    let params;
    params = new HttpParams()
      .set('pcsDescription', pcsDescription);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/getPcsCodeByPcsDescription', options);

    return this.http.get(this.baseUrl + '/trueclaim/icdcodes/getPcsCodeByPcsDescription', options);
  }

  getPcsDescriptionByPcsCode(pcsCode: any) {
    let params;
    params = new HttpParams()
      .set('pcsCode', pcsCode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.apiClaimsUrl + '/trueclaim/codes/getPcsDescriptionByPcsCode', options);

    return this.http.get(this.baseUrl + '/trueclaim/icdcodes/getPcsDescriptionByPcsCode', options);
  }


  getAllByEmployeeIdCorporate(companyId: any, employeeId: any) {
    let params;
    params = new HttpParams()
      .set('companyId', companyId)
      .set('employeeId', employeeId);

    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/member/get-all-by-employee-id-corporate', options);
  }

  getAllMemberDetailsById(memberId: any) {
    let params;
    params = new HttpParams()
      .set('memberId', memberId);

    const options = {
      params: params
    };
    return this.http.get(this.baseUrl + '  /trueclaim/member/get-all-member-details-by-id', options);
  }

  getProviderRooms(insurerId: any) {
    const param = new HttpParams()
      .set('providerBranchId', this.authService.currentUserValue.providerBranch.id)
      .append('insurerId', insurerId);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/tariffs/provider-get-room-tariff', httpOptions);
  }

  saveInvoice = (invoices: Array<any>): Observable<any> => {
    return this.http.post(this.baseUrl + "/trueclaim/claims/save-invoice-description", invoices);
  }

  getInvoiceBillGroup = (): Observable<any> => {
    const httpOption = {
      params: new HttpParams().set("claimType", "CASHLESS")
    }
    return this.http.get(this.baseUrl + "/trueclaim/claims/get-bill-group", httpOption);
  }

  getInvoiceBillCategories = (): Observable<any> => {
    return this.http.get(this.baseUrl + "/trueclaim/claims/get-all-bill-category");
  }

  getDescriptionObject(data: any) {
    const params = new HttpParams()
      .set('description', data);
    const httpOptions = {
      params: params,
    };
    return this.http.get(this.baseUrl + '/trueclaim/invoice/getObjectForDescription', httpOptions);
  }

  getRoomCategory() {
    return this.http.get(this.baseUrl + '/trueclaim/provider/fetchRoomCategory');
  }

  getProviderTariffForItems(tariffCriteria: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post(this.baseUrl + '/trueclaim/provider/item-tariff', tariffCriteria, httpOptions);

  }

  validateAadhar(aadhar_no: any) {
    const params = new HttpParams()
      .set('aadhar_number', aadhar_no);

    return this.http.get(this.baseUrl + '/trueclaim/claim/validateAadharNumber', { params: params });
  }

  validatePanNumber(pan_number: any) {
    const params = new HttpParams()
      .set('pan_number', pan_number);

    return this.http.get(this.baseUrl + '/trueclaim/claim/validatePanNumber', { params: params });
  }

  getAllInsurers() {
    return this.http.get(this.baseUrl + '/trueclaim/insurer/getAllInsurers');
  }

  getDoctorDetails(registrationNumber: any) {
    const params = new HttpParams()
      .set('docRegNumber', registrationNumber)
      .set('providerBranchProfileId', this.authService.currentUserValue.providerBranchProfile.id);

    return this.http.get(this.baseUrl + '/trueclaim/doctors/get-doctor-by-reg-num', { params: params });
  }

  saveClaim(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/save-draft-claim', newClaimDto);
  }

  submitQueryDocuments(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claim/submit-query-documents', newClaimDto);
  }

  queryResponded(newClaimDto: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post(this.baseUrl + '/trueclaim/claims/query-responded', newClaimDto, httpOptions);
  }

  queryRespondedNonRegistered(newClaimDto: any) {
     //Hospital Email
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post(this.baseUrl + '/trueclaim/claims/responded-query', newClaimDto, httpOptions);
  }


  
  uploadFinalBillsFromTPA(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claim/uploadFinalBillsFromTPA', newClaimDto);
  }

  uploadFileDispatchDetails(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/upload-file-dispatch-details-interface', newClaimDto);
  }

  requestDischarge(newClaimDto: any) {
    //return this.http.post(this.baseUrl + '/trueclaim/claims/final-bill-submit-with-direct-discharge', newClaimDto);
    return this.http.post(this.baseUrl + '/trueclaim/claims/final-bill-submit', newClaimDto);
  }

  editFinalBill(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claim/verifyFinalBills', data);
  }

  saveOrUpdateItem(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/invoice/saveInvoiceDescription', data);
  }

  autocompleteCompany(search: any, claimAdminId: any) {
    const params = new HttpParams().set('search', search).set('claimAdminId', claimAdminId)

    return this.http.get(this.baseUrl + '/trueclaim/claimant/autocomplete-company', { params: params });
  }

  cancelClaim(claimsDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/claims/cancel-claim', claimsDto);
  }

  getDocumentNameList() {
    return this.http.get(this.baseUrl + '/trueclaim/documents/getClaimInitiateDocumentTypes');
  }

  fetchInitiatedClaim(claimId: any) {
    const params = new HttpParams().set('claimId', claimId);
    return this.http.get(this.baseUrl + '/trueclaim/claim/fetchInitiatedClaim', { params: params });
  }

  getPreSignedUrlByKey(bucket: any, key: any) {
    const params = new HttpParams().set('bucket', bucket).set('key', key);
    return this.http.get(this.baseUrl + '/truecover/s3/get-pre-signed-url-by-key', { params: params });
  }

  statusWiseDocs(claimStatus: any) {
    const params = new HttpParams().set('claimStatus', claimStatus).set('claimType', 'CASHLESS');
    return this.http.get(this.baseUrl + '/trueclaim/claims/status-wise-docs', { params: params });
  }

  unProcessCashlessClaim(claimsDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-process-cashless-claim', claimsDto);
  }

  unApproveCashlessClaim(claimsDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-approve-cashless-claim', claimsDto);
  }

  unRejectCashlessClaim(claimsDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-reject-cashless-claim', claimsDto);
  }


  unRaisedQuery(newClaimDto: any) {
    //Claim Query DTO
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-raisedQuery', newClaimDto);
  }

  unRespondedQuery(newClaimDto: any) {
    //HospitalEmailDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-responded-query', newClaimDto);
  }

  unApproveClaim(newClaimDto: any) {
    //ClaimDetailsDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-approveClaim', newClaimDto);
  }

  unDischarge(newClaimDto: any) {
    //ClaimDetailsDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-discharge', newClaimDto);
  }

  unRejectClaim(newClaimDto: any) {
    //ClaimDetailsDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-rejectClaim', newClaimDto);
  }

  unSettledClaim(newClaimDto: any) {
    //ClaimDetailsDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-settled-claim', newClaimDto);
  }

  unEenhancement(newClaimDto: any) {
    //HospitalEmailDto
    return this.http.post(this.baseUrl + '/trueclaim/unregistered/un-raise-enhancement', newClaimDto);
  }

  
  getAllDiscountInsurer = (insurerId: any, tpaId: any, entityid: any, providerBranchId: any) => {
    const params = new HttpParams().set('insurerId', insurerId).set('tpaId', tpaId).
      set('entityId', entityid).set('providerBranchId', providerBranchId);
    return this.http.get(this.apiClaimsUrl + '/trueclaim/claim/get-discounts', { params: params });
  }

  getPreviousClaimStatus(claimId: any, lastMailTimeStamp: any) {
    let params;
    params = new HttpParams()
      .set('claimId', claimId).set('lastMailTimeStamp', lastMailTimeStamp);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claims/getPreviousClaimStatus', options);
  }

  getAllByAbhaMemberId(submit: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post(this.baseUrl + '/trueclaim/abha/searchAbhaUser', submit, httpOptions);
  }

  //new api services cashless-anywhere flow start
  getAllPayerList(){
    return this.http.get(this.baseUrl + '/trueclaim/provider/cashless-anywhere/get-all-payer');
  }

  submitCashlessAnywhereClaim(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/submit-claim', data);
  }

  cashlessAnyWherequeryResponded(newClaimDto: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/query-response ', newClaimDto, httpOptions);
  }
  cashlessAnyWhereraiseEnhancement(data: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/raise-enhancement', data);
  }
  cashlessAnyWhereRequestDischarge(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/final-bill-submit', newClaimDto);
  }
  cashlessAnyWherecancelClaim(claimsDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/cancel-claim', claimsDto);
  }
  cashlessAnyWhereuploadFinalBillsFromTPA(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/upload-final-bills-from-tpa', newClaimDto);
  }
  uploadFileDispatchDetailsCashlessanyWhere(newClaimDto: any) {
    return this.http.post(this.baseUrl + '/trueclaim/provider/cashless-anywhere/upload-file-dispatch-details-interface', newClaimDto);
  }
  //new api services cashless-anywhere flow end
 
  sendForFinovaIngestion(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const params = new HttpParams()
    .set('claimId', data.claimId)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      }),
      params: params
    };
  // TO CHANGE ID KEY
    return this.http.post(this.baseUrl + '/trueclaim/claim/sendFinovaIngestion', {}, httpOptions);

  }
  sendLendingOtherClaims(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };

  // TO CHANGE ID KEY
    return this.http.post(this.baseUrl + '/trueclaim/claim/sendLendingOtherClaims', data, httpOptions);

  }
  
  getAllTariffMappingForHospital() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      // params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getAllMappedTariffforHospital', options);
  }
  providerMappingV1(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/provider/providerMappingV1', data, httpOptions); // TO CHANGE API
  }
  getInsurerGroupName() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
    };
    // return this.http.get(this.baseUrl + '/trueclaim/insurer/getAllInsurerDisplayNames', options);
    return this.http.get(this.baseUrl + '/trueclaim/insurer/getAllInsurerDisplayNamesForHealth', options);
  }

  getClaimAdministratorName() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
    };
    return this.http.get(this.baseUrl + '/trueclaim/claimAdministrator/getAllClaimAdminNames', options);
  }
  autocompleteTariffRef(query: any) {
    const params = new HttpParams()
      .set('queryString', query);
    let token;
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } else if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
        .set('Content-Type', 'application/json')
        .set("Access-Control-Allow-Origin", "*"),
      params: params,
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/searchAutoCompleteTariffRef', options);
  }
  addProviderRoomTariff(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/provider/addProviderRoomTariff', data, httpOptions); // TO CHANGE API
  }

  getinsuerDetails(insurerId:any,providerBranchId:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } const params = new HttpParams()
      .set('providerBranchId', providerBranchId)
      .set('insurerId', insurerId)

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/provider/getProviderRoomTariffDisplay', options);
  }
  uploadAutoHospitalDiscount(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/upload-auto-hospital-discount', data, httpOptions);// /trueclaim/tariffs/uploadDiscounts', data, httpOptions); // TO CHANGE API
  }

  getAllHospitalDetails(providerId: any, insurerId?:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }

    const params = insurerId ? new HttpParams().set("insurerId", insurerId).set("hospitalId", providerId) : new HttpParams().set("providerId", providerId);
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    // return this.http.get(this.baseUrl + "/trueclaim/get-hospital-details", options);    //'/trueclaim/tariffs/getAllDiscounts', options);
    return this.http.get(this.baseUrl + "/trueclaim/auto-diiscount-hospital-list", options);    //'/trueclaim/tariffs/getAllDiscounts', options);
  }
  getAllEntity = (): Observable<any> => {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.get(this.baseUrl + "/trueclaim/entity/getAllActiveEntityDetails", httpOptions);
  }

  rejectTariff(tariffId:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const params = new HttpParams()
      .set('tariffId', tariffId); // TO CHANGE ID KEY

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/rejectTariff', options);
  }
  approveTariff(tariffId:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const params = new HttpParams()
      .set('tariffId', tariffId); // TO CHANGE ID KEY

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/approveTariff', options);
  }
  uploadHospitalBulkUpload(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/provider/uploadBulkRoomTariffDetails', data, httpOptions);
  }
  uploadTariff(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/uploadTariff', data, httpOptions);
  }
  getItemsForMappedTariff(id:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const params = new HttpParams()
      .set('providerMappingId', id); // TO CHANGE ID KEY

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getItemsForMappedTariff', options);
  }
  getAllBillingGroup() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getAllBillingGroup', options);
  }
  getAllBillingSystem() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getAllBillingSystem', options);
  }

  getAllBillingSubGroupByBillingGroup(billingGroup:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const params = new HttpParams()
      .set('billingGroup', billingGroup); // TO CHANGE ID KEY

    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/getAllBillingSubGroupByBillingGroup', options);
  }
  updateTariff(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/updateAllTariff', data, httpOptions); // TO CHANGE API
  }

  getDefaultTariff() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const options = {
      headers: new HttpHeaders().set('Authorization', 'Token ' + token)
    };
    return this.http.get(this.baseUrl + '/trueclaim/tariffs/get-default-tariff', options);
  }
  
  updateTariffItems(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/update-tariff-items', data, httpOptions); // TO CHANGE API
  }



  deleteTariffItems(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/delete-tariff-items', data, httpOptions); // TO CHANGE API
  }


  approveTariffItems(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/approve-tariff-itens', data, httpOptions); // TO CHANGE API
  }


  rejectTariffItems(data:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(this.baseUrl + '/trueclaim/tariffs/reject-tariff-items', data, httpOptions); // TO CHANGE API
  }

  sendForFinovaLogin() {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    // const params = new HttpParams()
    // .set('claimId', data.claimId)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      }),
      // params: params
    };
    return this.http.post(this.baseUrl + '/trueclaim/claim/finovaSSO',{}, httpOptions);

  }
    getClaimLetterData(token: string) {
    const params = new HttpParams().set('token', token);
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(this.baseUrl + '/trueclaim/claim/get-letters-by-claim', options);
  }
}
